import React from 'react';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import CheckIcon from '@material-ui/icons/CheckBox';
import ThresholdButton from './ThresholdButton';
import { styles } from '../styles/form-styles';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

class ThresholdSetting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cutoff: '',
      buttonDisabled: true,
      isLoading: false
    }
  }
  onChange = (e) => {
    this.setCutoff(e)
    this.setDisabled(false);
  }
  setCutoff = (e) => {
    this.setState({
      cutoff: e.target.value
    })
  }
  setDisabled = (value) => {
    this.setState({
      buttonDisabled: value
    })
  }
  handleSave = (e) => {
    this.setDisabled(true);
    this.props.handleDeleteAlertsFromState(this.props.monitorId);
    // this.props.handleAlerts(null);
    this.props.handleAlertCutoffChange(this.props.monitorId, this.state.cutoff)
    // this.props.handleAlertsLoading();
    
  }
  componentDidMount() {
    this.setState({
      cutoff: this.props.alertCutoff,
      isLoading: this.props.alertsLoading
    })
  }
  componentDidUpdate(prevProps) {
    if(prevProps.alertCutoff !== this.props.alertCutoff) {
      this.setState({
        buttonDisabled: true
      })
    }
  }
  render() {
    const {classes} = this.props;
    const buttonColor = this.state.buttonDisabled ? "disabled" : "secondary";

    return (
      <form className={classes.container} noValidate autoComplete="off">
        <TextField
          id="alertCutoff"
          label="Alert threshold:"
          helperText={`${this.props.unit}`}
          defaultValue={this.props.alertCutoff}
          className={classes.textField}
          margin="normal"
          type="number"
          onChange={e => {this.onChange(e)}}
        />
        <ThresholdButton 
        handleSave={this.handleSave} 
        disabled={this.state.buttonDisabled} 
        color={buttonColor}
      />
      </form>
    )
  }
}

ThresholdSetting.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ThresholdSetting);


// WEBPACK FOOTER //
// ./src/components/ThresholdSetting.js